import { Put, Post, Delete, Get } from "./common";

export default class CategoryService {
  static getByParentCategory = async (data: any) =>
    await Post({ path: "sub-categories/by-category", body: data });

  static list = async (token: string, data: any) =>
    await Post({ path: "sub-categories/list", token, body: data });

  static create = async (token: string, data: any) =>
    await Post({ path: "sub-categories", token, body: data });

  static update = async (token: string, id: string, data: any) =>
    await Put({ path: `sub-categories/${id}`, token, body: data });

  static getById = async (id: string, token: string) =>
    await Get({ path: `sub-categories/${id}`, token });

  static deleteById = async (id: string, token: string) =>
    await Delete({ path: `sub-categories/${id}`, token });
}
